export default {
  funeralHomeOrders: [
    'created_at',
    'sortable_created_at',
    'sortable_date_of_death',
  ],
  case: ['date_of_death', 'date_of_birth', 'created_at'],
}
